import { Utils } from './utils';

// ================================================================
// スライダー機能
// ================================================================

// -----------------------------------------------
// FVスライダー初期化
// -----------------------------------------------
export function initFvSlider() {
  const element = document.querySelector('.js-fv-slider');

  if (!element) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  try {
    new Swiper('.js-fv-slider', {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      speed: 3100,
      allowTouchMove: false,
      autoplay: {
        delay: 3100,
        disableOnInteraction: false,
      },
    });
  } catch (error) {
    console.error('Failed to initialize FV slider:', error);
  }
}

// -----------------------------------------------
// プロパティスライダー初期化
// -----------------------------------------------
export function initPropertySliders() {
  // 売主物件スライダー
  initPropertySlider('.js-property-list-purchased', {
    delay: 4000,
    spaceBetween: 20,
  });

  // 保有物件スライダー
  initPropertySlider('.js-property-list-owned', {
    delay: 4500,
    spaceBetween: 20,
  });
}

// -----------------------------------------------
// コンサルタントスライダー初期化
// -----------------------------------------------
export function initConsultantSlider() {
  initSingleSlider('.js-consultant-slider', {
    delay: 5000,
    wrapperClass: '.svc-consultant__slider-wrapper',
    nextClass: '.svc-consultant__next',
    prevClass: '.svc-consultant__prev',
  });
}

// -----------------------------------------------
// プロパティスライダー個別初期化
// -----------------------------------------------
function initPropertySlider(selector, options = {}) {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  // 親要素（list-wrapper）を取得
  const sliderWrapper = element.closest('.top-property__list-wrapper');
  
  // ナビゲーション要素を取得
  let nextEl = null;
  let prevEl = null;
  let paginationEl = '.swiper-pagination';
  
  if (sliderWrapper) {
    nextEl = sliderWrapper.querySelector('.top-property__next');
    prevEl = sliderWrapper.querySelector('.top-property__prev');
    const pagination = sliderWrapper.querySelector('.swiper-pagination');
    if (pagination) {
      paginationEl = pagination;
    }
  }

  try {
    new Swiper(selector, {
      slidesPerView: 1,
      spaceBetween: options.spaceBetween || 20,
      loop: true,
      autoplay: {
        delay: options.delay || 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: false,
          loop: false,
        }
      }
    });
  } catch (error) {
    console.error(`Failed to initialize slider ${selector}:`, error);
  }
}

// -----------------------------------------------
// 汎用スライダー初期化
// -----------------------------------------------
function initSingleSlider(selector, options = {}) {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  // 親要素（slider-wrapper）を取得
  const sliderWrapper = element.closest(options.wrapperClass);
  
  // ナビゲーション要素を取得
  let nextEl = null;
  let prevEl = null;
  
  if (sliderWrapper) {
    nextEl = sliderWrapper.querySelector(options.nextClass);
    prevEl = sliderWrapper.querySelector(options.prevClass);
  }

  try {
    new Swiper(selector, {
      slidesPerView: 1,
      loop: true,
      autoHeight: false, // 自動高さ調整を無効化
      watchSlidesProgress: true, // スライドの進行状況を監視
      normalizeSlideIndex: false, // スライドインデックスの正規化を無効化
      // autoplay: {
      //   delay: options.delay || 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  } catch (error) {
    console.error(`Failed to initialize slider ${selector}:`, error);
  }
} 